import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
 
import { MatTableDataSource } from '@angular/material/table';
import { Prospect, Packagesponsor } from 'src/app/entity/prospect';
import { PackagesponsorService } from 'src/app/service/package.service';
import { PackageDialogComponent } from './package-dialog/package-dialog.component';

@Component({
  selector: 'app-package-sponsor',
  templateUrl: './package-sponsor.component.html',
  styleUrls: ['./package-sponsor.component.css'],   styles: [`
  .p-steps .p-steps-item {
      width: 25%!important;
  }

  .p-steps.steps-custom {
      margin-bottom: 30px!important;
  }

  .p-steps.steps-custom .p-steps-item .p-menuitem-link {
      padding: 0 1em!important;
      overflow: visible!important;
  }

  .p-steps.steps-custom .p-steps-item .p-steps-number {
      background-color: #0081c2!important;
      color: #FFFFFF!important;
      display: inline-block!important;
      width: 36px!important;
      border-radius: 50%!important;
      margin-top: -14px!important;
      margin-bottom: 10px!important;
  }

  .p-steps.steps-custom .p-steps-item .p-steps-title {
      color: #555555!important;
  }
`],
})
export class PackageSponsorComponent implements OnInit,OnChanges {


 
  dataSource = new MatTableDataSource();
  idClient: number;
  packageProspect: Packagesponsor

  @ViewChild(PackageDialogComponent)
  private packageDialogComponent: PackageDialogComponent;


  @Input() prospect: Prospect

  displayedColumns: string[] = ['designation', 'quantite', 'prixunit', 'stotal'];

  constructor(private packageService: PackagesponsorService
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.findPackage(this.prospect)
  }

  ngOnInit() {

  }
 
  clickedMe() {

this.  editPackage();
  }


  findPackage(prospect: Prospect) {
    this.packageService.getByProspect(prospect.prospectId).subscribe(p => {
      this.packageProspect = p;
      if(p)
      document.getElementById('pack').innerHTML=p.detail
      else
      document.getElementById('pack').innerHTML=""
    }
    );
  }
  editPackage() {
 
      this.packageDialogComponent.editPackage(this.prospect);

  
  }
  printPackage(isSpeaker: boolean) {
    this.packageDialogComponent.printPackage(this.prospect, isSpeaker);
  }
}
